// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILockReasonTypeDto
 */
export interface ILockReasonTypeDto {
    /**
     * 
     * @type {number}
     * @memberof ILockReasonTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockReasonTypeDto
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockReasonTypeDto
     */
    description?: string;
}

/**
 * Check if a given object implements the ILockReasonTypeDto interface.
 */
export function instanceOfILockReasonTypeDto(value: object): value is ILockReasonTypeDto {
    return true;
}

export function ILockReasonTypeDtoFromJSON(json: any): ILockReasonTypeDto {
    return ILockReasonTypeDtoFromJSONTyped(json, false);
}

export function ILockReasonTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILockReasonTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ILockReasonTypeDtoToJSON(json: any): ILockReasonTypeDto {
    return ILockReasonTypeDtoToJSONTyped(json, false);
}

export function ILockReasonTypeDtoToJSONTyped(value?: ILockReasonTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reason': value['reason'],
        'description': value['description'],
    };
}

